import { useMemo } from 'react';
import { useSelector, authSelectors, warehousesSelectors } from '../state';

export function useGetUsersData() {
  const authData = useSelector(authSelectors.authData);
  const selectedWarehouseId = useSelector(warehousesSelectors.selectedWarehouseId);

  return useMemo(() => {
    // If user already has a warehouse assigned, use that
    // Otherwise, use the globally selected warehouse if available
    const userWarehouseId = authData.userWarehouseId || selectedWarehouseId || undefined;
    
    return { 
      ...authData,
      userWarehouseId
    };
  }, [authData, selectedWarehouseId]);
}
